export type AdvertiserReportPageTemplate = {
  label: string
  input: string
}

/**
 * Starter set of default page prompts for an advertiser report. Each template
 * seeds the page's `input` textarea; the admin can edit it freely afterwards.
 * "Custom (blank)" leaves the input empty so the admin writes their own prompt.
 * Texts are intentionally generic placeholders and can be refined later.
 */
export const ADVERTISER_REPORT_PAGE_TEMPLATES: AdvertiserReportPageTemplate[] = [
  {
    label: 'Custom (blank)',
    input: '',
  },
  {
    label: 'Cover slide',
    input:
      'Cover slide: report title, the advertiser name, the reporting date range, and the market/country. Keep it clean and on-brand.',
  },
  {
    label: 'Campaign overview',
    input:
      'Campaign overview: total clicks, total order value, conversion rate, and number of active creators for the period, each compared against the previous period.',
  },
  {
    label: 'Top creators',
    input:
      'Top creators: a ranked breakdown of the creators that drove the most order value, with their clicks, conversion rate, and order value.',
  },
  {
    label: 'Conversion & order value',
    input:
      'Conversion and order value: a monthly trend of order value and conversion across the period, highlighting the strongest and weakest months and likely drivers.',
  },
  {
    label: 'Closing / next steps',
    input:
      'Closing slide: a short summary of the key takeaways from the campaign and 3-5 concrete, actionable recommendations for the next period.',
  },
]
